
import { mapGetters } from 'vuex';
import { defineComponent } from 'vue';
import { authClient } from '@/apis';
import log from '@/utils/log';

export default defineComponent({
  data: () => ({
    name: '',
    email: '',
    code: '',
    password: '',
    confirmPassword: '',
    alertType: 'success',
    alertShown: false,
    alertContent: '',

    cooldownCnt: 0,
    state: 'init',
  }),
  computed: {
    ...mapGetters(['userLoggedIn']),
    realEmail(): string {
      return `${this.email}@fudan.edu.cn`;
    },
  },
  mounted() {
    // 若用户已登录，跳转至个人首页
    if (this.userLoggedIn) {
      this.$router.push('/user');
    }
  },
  methods: {
    register() {
      if (this.password !== this.confirmPassword) {
        this.$message.warn('两次输入密码不一致');
        return;
      }
      if (this.name === '') {
        this.$message.warn('名称不能为空哦');
        return;
      }
      if (!/^\d{11}@fudan\.edu\.cn$/.test(this.realEmail)) {
        this.$message.warn('请输入11位学号邮箱');
        return;
      }
      if (!/^\d{6}$/.test(this.code)) {
        this.$message.warn('请输入6位验证码');
        return;
      }
      if (this.password === '') {
        this.$message.warn('密码不能为空哦');
        return;
      }
      if (this.password.length < 6) {
        this.$message.warn('密码长度至少为 6 个字符哦');
        return;
      }
      if (this.password.length > 32) {
        this.$message.warn('密码长度最多为 32 个字符哦');
        return;
      }
      authClient.register({
        name: this.name,
        email: this.realEmail,
        code: parseInt(this.code, 10),
        password: this.password,
      })
        .then(() => {
          this.$message.success('注册成功');
          setTimeout(() => {
            this.$router.push({ name: 'Login' });
          }, 500);
        });
    },
    requestCode() {
      if (this.state === 'init' || this.state === 'resend') {
        if (!/^\d{11}@fudan\.edu\.cn$/.test(this.realEmail)) {
          this.$message.warn('请输入11位学号邮箱');
          return;
        }
        this.state = 'requesting';
        authClient.requestCodeRegister({ email: this.realEmail })
          .then(() => {
            this.state = 'cooldown';
            this.cooldownCnt = 60;
            this.$message.success('验证码发送成功');
            const countdown = () => {
              this.cooldownCnt -= 1;
              if (this.cooldownCnt <= 0) this.state = 'resend';
              else if (this.state === 'cooldown') setTimeout(countdown, 1000);
            };
            setTimeout(() => countdown(), 1000);
          })
          .catch((e) => {
            this.state = 'init';
            const code = e.response.status;
            if (code === 400) this.$message.error(e.response.data.message);
            else if (code === 409) this.$message.error('该邮箱已被注册');
            else log.error('Error: unexpected code');
          });
      } else if (this.state === 'cooldown' || this.state === 'requesting') {
        log.error('Warning: cooldown-ing or requesting');
      } else {
        log.error('Error: Unexpected state');
      }
    },
  },
});
